import { axiosInstance } from './req';


export const createGeoFence = async (deviceUUID: string, active: boolean, latLongs: number[][] ): Promise<any> => {
    return axiosInstance.post(`/api/geo-fence/${deviceUUID}`, { deviceUUID, latLongs, active }).then(({ data }) => data)
};

export const updateGeoFence = async (deviceUUID: string, action: string) => {
    return axiosInstance.put(`/api/geo-fence/${deviceUUID}/${action}`).then(({ data }) => data);
};

export const getDeviceGeoFence = async (deviceUUID: string) => {
    return axiosInstance.get(`/api/geo-fence/${deviceUUID}`).then(({ data }) => data);
};